/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import React, { useEffect, useState } from 'react';
import CustomDataTable from '../CustomDataTable/CustomDataTable';
import { getAllUsersData } from 'src/services/userService';
import { Grid, IconButton, Menu, MenuItem } from '@mui/material';
import type { TableColumn } from 'react-data-table-component';
import MUIModal from '../MUIModal/MUIModal';
import AddUserForm from './AddUserForm';
import { Link, useNavigate } from 'react-router-dom';
import GradientButton from '../MUICustomButton/GradientButton';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import { UPDATE_USER_ACTIVATE_SUBTITLE_1, UPDATE_USER_ACTIVATE_SUBTITLE_2, UPDATE_USER_DEACTIVATE_SUBTITLE_1, UPDATE_USER_DEACTIVATE_SUBTITLE_2, UPDATE_USER_DELETE_SUBTITLE_1, UPDATE_USER_DELETE_SUBTITLE_2 } from 'src/constants/constant';
import OutlineButton from '../MUICustomButton/OutlineButton';
import { deleteUserData, activateOrDeactivate } from 'src/services/userService';
import type { activeOrDeactiveProps, RootState } from '../types/types';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { useDispatch, useSelector } from 'react-redux';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { MoreVerticalSolidRounded } from '@hugeicons-pro/core-solid-rounded';
//@ts-ignore
import { MultiplicationSignStrokeStandard } from '@hugeicons-pro/core-stroke-standard';
//@ts-ignore
import { PencilEdit02Icon } from '@hugeicons-pro/core-stroke-rounded';
import { checkEventPermission } from "../../common/utility/utility";
import { useAuth } from 'src/context/AuthContext';
import { clearAuthData } from 'src/store/slices/authSlice';
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const ITEM_HEIGHT = 48;

interface UserListPropType {
  "id": number;
  "firstName": string;
  "lastName": string;
  "email": string;
  "password": string | null;
  "isDeleted": boolean;
  "isActive": boolean;
  "createdBy": number;
  "createdOn": string;
  "updatedBy": number;
  "updatedOn": string;
  "deletedBy": string | null;
  "deletedOn": string | null;
  "roleName": string;
  "roleId": number | 0;
}

interface UserListPropType1 {
  "id": number;
  "firstName": string;
  "lastName": string;
  "fullName": string;
  "email": string;
  "password": string | null;
  "isDeleted": boolean;
  "isActive": boolean;
  "createdBy": number;
  "createdOn": string;
  "updatedBy": number;
  "updatedOn": string;
  "deletedBy": string | null;
  "deletedOn": string | null;
  "roleName": string;
  "roleId": number | 0;
};

interface ApiResponse {
  status: number;
  data: {
    data: UserListPropType[];
    result: number;
  };
}

interface UserDeleteIds {
  "userId": number;
}
interface UserDeleteProps {
  "modifiedBy": number;
  "userLst": UserDeleteIds[];
}

const UserList: React.FC = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userListData, setUserListData] = useState<UserListPropType1[]>([])
  const [userSearchData, setUserSearchData] = useState<UserListPropType1[]>([])

  const [openAddUserModal, setOpenAddUserModal] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(true)
  const [showDeleteUserModal, setShowDeleteUserModal] = useState<boolean>(false)
  const [isModalSaveLoading, setIsModalSaveLoading] = useState<boolean>(false)
  const [selectedUserData, setSelectedUserData] = useState<UserListPropType>();
  const [showDeactivateUserModal, setShowDeactivateUserModal] = useState<boolean>(false)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [anchorActionEl, setAnchorActionEl] = React.useState<any>({});
  const { user } = useSelector((state: RootState) => state.auth);
  console.log(user);
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    getUserListData()
  }, [user])
  const handleLogout = (): void => {
    localStorage.clear();
    logout();
    dispatch(clearAuthData());
    navigate('/');
  };
  const getUserListData = (): void => {
    setLoading(true);
    const ClientId = user?.clientId ?? 0;
    const RoleId = user?.roleID ?? 0;
    getAllUsersData(ClientId, RoleId)
      .then(
        (res: ApiResponse) => {
          if (res.status === 200) {
            if (res.data.result === 1) {
              const userArr: UserListPropType1[] = [];
              res.data.data.map((user: any) => {
                user.fullName = `${user.firstName} ${user.lastName}`
                userArr.push(user)
              })
              setUserListData(userArr)
              setUserSearchData(userArr)
            } else {
              setUserListData([])
              setUserSearchData([])
            }
          }
        }
      )
      .catch(
        error => console.log("Error: ", error)
      )
      .finally(() => {
        setLoading(false)
      })
  }

  const handleAddUserClick = (): void => {
    setOpenAddUserModal(true)
  }

  const handleCloseAddUserModal = (): void => {
    setOpenAddUserModal(false)
  }

  const handleRefreshPage = (): void => {
    getUserListData()
    handleCloseAddUserModal()
  }

  const handleActionClick = (event: React.MouseEvent<HTMLElement>, id: number): void => {
    // anchorActionEl[id] = event.currentTarget
    setAnchorActionEl({ ...anchorActionEl, [id]: event.currentTarget });
  }

  const handleActionClose = (event: React.MouseEvent<HTMLElement>, rowData: UserListPropType, action: string | null = null): void => {
    setSelectedUserData(rowData)
    if (action === "delete") {
      setShowDeleteUserModal(true)
    } else if (action === "deactivate" || action === "activate") {
      setShowDeactivateUserModal(true)
    }
    setAnchorActionEl({ ...anchorActionEl, [rowData.id]: null });
  }

  const handleDeleteUserClose = (): void => {
    setShowDeleteUserModal(false)
  }
  const handleDeactivateUserClose = (): void => {
    setShowDeactivateUserModal(false)
  }
  const handleDeleteUserConfirm = (): void => {
    setIsModalSaveLoading(true)
    const userId: number = selectedUserData !== undefined ? selectedUserData.id : 0
    const data: UserDeleteProps = {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      "modifiedBy": user.id,
      "userLst": [{
        "userId": userId
      }]
    }

    deleteUserData(data)
      .then(
        res => {
          if (res.status === 200) {
            if (user?.id === userId) {
              handleLogout();
            }
            NotificationManager.success("User deleted successfully")
            setIsModalSaveLoading(false)
            setShowDeleteUserModal(false)
            getUserListData()
          }
        }
      )
      .catch(
        error => console.log("Error in delete user: ", error)
      )
  }
  const handleDeactivateUserConfirm = async (): Promise<void> => {
    const userId: number = selectedUserData?.id ?? 0;
    const modifiedBy: number = user?.id ?? 0;

    setIsModalSaveLoading(true);

    const data: activeOrDeactiveProps = {
      modifiedBy,
      userLst: [{ userId }],
      activeOrDeActive: ((selectedUserData?.isActive) === true) ? 0 : 1,
    };

    try {
      const res = await activateOrDeactivate(data);

      if (res.status === 200 && res.data.result === 1) {
        NotificationManager.success(
          ((selectedUserData?.isActive) === true)
            ? "User deactivated successfully"
            : "User activated successfully"
        );

        getUserListData();
      }
    } catch (error) {
      console.error("Error activating/deactivating user:", error);
      NotificationManager.error("An error occurred. Please try again.");
    } finally {
      setShowDeactivateUserModal(false);
      setIsModalSaveLoading(false);
    }
  };
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { value } = e.target;
    let userDataArr = [...userListData]
    if (value !== "") {
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-optional-chain
      userDataArr = userDataArr && userDataArr.filter((user: UserListPropType1) => {
        return user.fullName.toLowerCase().search(value.toLowerCase()) >= 0 || user.email.toLowerCase().search(value.toLowerCase()) >= 0
      })
    }

    setUserSearchData(userDataArr)
  }

  const columns: TableColumn<UserListPropType>[] = [
    {
      name: 'Full Name',
      selector: (row: UserListPropType) => row.firstName,
      cell: (row: UserListPropType) => {
        return (
          <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>
            <div className="overflow-hidden" style={{ width: '100%' }}>
              <p className="text-14 text-muted">{row.firstName} {row.lastName}</p>
            </div>
          </div>
        )
      },
      width: '25%',
      sortable: true
    },
    {
      name: 'Email',
      selector: (row: UserListPropType) => row.email,
      width: '25%',
      sortable: true
    },
    {
      name: 'Role',
      selector: (row: UserListPropType) => row.roleName,
      width: '25%',
      sortable: true
    },
    {
      name: 'Status',
      sortable: false,
      width: "15%",
      // selector: row => row.year,
      cell: (row: UserListPropType) => {
        return row.isActive ? <div className="badge truncate" style={{
          background: '#CCFFEA',
          padding: '10px 15px',
          color: '#06A864',
          border: '0px'
        }}>Active</div> : <div className="badge truncate" style={{
          background: '#FFF5F6',
          padding: '10px 15px',
          color: '#F13139',
          border: '0px'
        }}>Inactive</div>
      },
      center: true,
    },
    {
      name: 'Action',
      // selector: (row: any) => row.role,
      cell: (row: UserListPropType) => {
        console.log("anchorActionEl", anchorActionEl)
        return (
          <div className='flex items-center'>
            <div className='icon-hover-container'>
              <Link to={`/admin/manage-users/edit/${row.id}`} style={{ width: '20px' }}>
                <HugeiconsIcon
                  icon={PencilEdit02Icon}
                  size={20}
                  color="#3A3A3A"
                  strokeWidth={0.2}
                />
              </Link>
            </div>
            <div className='flex'>
              {(checkEventPermission("USERS_ACTIVATE") || checkEventPermission("USERS_DELETE")) &&
                <>
                  <IconButton
                    aria-label="more"
                    id="long-button"
                    // aria-controls={open ? 'long-menu' : undefined}
                    // aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={(e) => handleActionClick(e, row.id)}
                  >
                    <HugeiconsIcon
                      icon={MoreVerticalSolidRounded}
                      size={20}
                      color="#3A3A3A"
                      strokeWidth={0.2}
                    />
                  </IconButton>
                  <Menu
                    id={`${row.id}`}
                    className='table-action-menu'
                    MenuListProps={{
                      'aria-labelledby': 'long-button',
                    }}
                    anchorEl={anchorActionEl[row.id]}
                    open={Boolean(anchorActionEl[row.id])}
                    onClose={() => setAnchorActionEl({ ...anchorActionEl, [row.id]: null })}
                  slotProps={{ paper: {
                      style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: '14ch',
                      },
                    }}}
                  >
                    {row.isActive && row.roleId !== null && row.password !== '' && row.password !== null && sessionStorage.getItem('roleName') === 'Super Admin' && 
                    <MenuItem onClick={(e) => handleActionClose(e, row, "loginAsUser")}>
                      <span className='text-muted font-normal'>Login as User</span>
                    </MenuItem>
                  } 
                    {checkEventPermission("USERS_ACTIVATE") &&
                      <MenuItem onClick={(e) => handleActionClose(e, row, row.isActive ? "deactivate" : "activate")}>
                        <span  className='text-muted font-normal'>{row.isActive ? "Deactivate" : "Activate"}</span>
                      </MenuItem>
                    }
                    {checkEventPermission("USERS_DELETE") &&
                      <MenuItem onClick={(e) => handleActionClose(e, row, "delete")}>
                        <span style={{color: '#F13139' }}>Delete</span>
                      </MenuItem>
                    }
                  </Menu>
                </>
              }
            </div>

          </div>
        )
      },
      width: '7%',
      sortable: false
    },

  ]
  return (
    <>
      <h2 className="text-2xl font-semibold text-title">Manage Users</h2>
      <div className="mt-[20px] mb-[20px] live-outreach-container">
        <Grid container spacing={2} alignItems={'center'}>
          <Grid item xs={12} sm={6} md={6} lg={4}>
            <div className="w-full">
              <input
                type="text"
                placeholder="Search by full name or email"
                className="input input-bordered search-input-white focus:ring-0 focus:outline-none border-[#E6ECF2] font-normal text-14 text-muted w-full"
                onChange={handleSearch}
              />
            </div>
          </Grid>
          <Grid item xs={6} md={6} lg={8} className='bulk-action flex justify-end'>
            {checkEventPermission("USERS_ADD") &&
              <GradientButton color='red' onClick={handleAddUserClick}>
                <span style={{
                  width: "20px",
                  height: "20px",
                  background: "#fff",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "50px",
                  marginRight: "5px"
                }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="19" viewBox="0 0 19 19" fill="none">
                    <path d="M17.5411 10.3185H1.03183C0.467764 10.3185 0 9.85078 0 9.28671C0 8.72265 0.467764 8.25488 1.03183 8.25488H17.5411C18.1052 8.25488 18.573 8.72265 18.573 9.28671C18.573 9.85078 18.1052 10.3185 17.5411 10.3185Z" fill="#F13139" />
                    <path d="M9.28671 18.573C8.72265 18.573 8.25488 18.1052 8.25488 17.5411V1.03183C8.25488 0.467764 8.72265 0 9.28671 0C9.85078 0 10.3185 0.467764 10.3185 1.03183V17.5411C10.3185 18.1052 9.85078 18.573 9.28671 18.573Z" fill="#F13139" />
                  </svg>
                </span>
                Add New User
              </GradientButton>
            }
          </Grid>
        </Grid>
      </div>
      {/* <div className="flex my-5 gap-x-2 justify-between items-center">
        <div className="basis-3/5">
          <div className="form-control">
            <input type="text" placeholder="Search by Full name or Email" className="input input-bordered search-input-white focus:ring-0 focus:outline-none border-[#E6ECF2] font-normal text-14 text-muted w-full" onChange={handleSearch} />
          </div>
        </div>
        <div className="basis-2/5 justify-end flex">
          {checkEventPermission("USERS_ADD") &&
            <GradientButton color='red' onClick={handleAddUserClick}>
              <span style={{
                width: "20px",
                height: "20px",
                background: "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50px",
                marginRight: "5px"
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="19" viewBox="0 0 19 19" fill="none">
                  <path d="M17.5411 10.3185H1.03183C0.467764 10.3185 0 9.85078 0 9.28671C0 8.72265 0.467764 8.25488 1.03183 8.25488H17.5411C18.1052 8.25488 18.573 8.72265 18.573 9.28671C18.573 9.85078 18.1052 10.3185 17.5411 10.3185Z" fill="#F13139" />
                  <path d="M9.28671 18.573C8.72265 18.573 8.25488 18.1052 8.25488 17.5411V1.03183C8.25488 0.467764 8.72265 0 9.28671 0C9.85078 0 10.3185 0.467764 10.3185 1.03183V17.5411C10.3185 18.1052 9.85078 18.573 9.28671 18.573Z" fill="#F13139" />
                </svg>
              </span>
              Add New User
            </GradientButton>
          }
        </div>
      </div> */}
      <div className='data-table-container mb-10 custom-table-container te-table-container'>
        <CustomDataTable
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          columns={columns}
          // for non super admin users we dont need to show the super admin user details
          data={user?.roleID === 1 ? userSearchData : userSearchData.filter(user => user.roleId !== 1)}
          pagination
          // selectableRows
          progressPending={loading}
        />

        <MUIModal title='Add User' openModal={openAddUserModal} closeModal={handleCloseAddUserModal} width={'50%'} >
          <AddUserForm closeModal={handleCloseAddUserModal} refreshPage={handleRefreshPage} />
        </MUIModal>

        <BootstrapDialog
          onClose={handleDeleteUserClose}
          aria-labelledby="customized-dialog-title"
          open={showDeleteUserModal}
          PaperProps={{
            sx: {
              width: '550px',
              height: '200px'
            },
          }}
        >
          <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
            Delete User
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleDeleteUserClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <HugeiconsIcon
              icon={MultiplicationSignStrokeStandard}
              size={24}
              color="currentcolor"
              strokeWidth={0.5}
            />
          </IconButton>
          <DialogContent>
            <p className='text-14 text-muted'>{UPDATE_USER_DELETE_SUBTITLE_1} <span className='font-semibold'>{`${selectedUserData !== undefined ? selectedUserData.firstName : ''} ${selectedUserData !== undefined ? selectedUserData.lastName : ''}`}</span> {UPDATE_USER_DELETE_SUBTITLE_2}</p>
          </DialogContent>
          <DialogActions sx={{ background: '#F9F9F9' }}>
            {/* <Button isGradient color="primary" label="Update" onClick={handleAssigneeClose} /> */}
            {/* <Button btntype={"button"} onClick={handleDeleteUserClose} label={"Cancel"} type={'default'} size={'small'} disabled={isModalSaveLoading}></Button> */}
            <OutlineButton color='gray' onClick={handleDeleteUserClose} width='130px'>Cancel</OutlineButton>
            {/* <Button btntype="submit" label={!isModalSaveLoading ? "Delete" : <span className="loading loading-spinner loading-xs text-white"></span>} isGradient={true} color={"primary"} size={"small"} onClick={handleDeleteUserConfirm} disabled={isModalSaveLoading}></Button> */}
            <GradientButton color='red' onClick={handleDeleteUserConfirm} width='130px'>{!isModalSaveLoading ? 'Delete' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
          </DialogActions>
        </BootstrapDialog>
        <BootstrapDialog
          onClose={handleDeactivateUserClose}
          aria-labelledby="customized-dialog-title"
          open={showDeactivateUserModal}
          PaperProps={{
            sx: {
              width: '550px',
              height: '200px'
            },
          }}
        >
          <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
            {selectedUserData && selectedUserData.isActive === true ? "Deactivate User" : "Activate User"}
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleDeactivateUserClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <HugeiconsIcon
              icon={MultiplicationSignStrokeStandard}
              size={24}
              color="currentcolor"
              strokeWidth={0.5}
            />
          </IconButton>
          <DialogContent>
            {
              selectedUserData && selectedUserData.isActive === true ?
                <p className='text-14 text-muted'>{UPDATE_USER_DEACTIVATE_SUBTITLE_1} <span className='font-semibold'>{`${selectedUserData.firstName} ${selectedUserData.lastName}`}</span> {UPDATE_USER_DEACTIVATE_SUBTITLE_2}</p>
                :
                <p className='text-14 text-muted'>{UPDATE_USER_ACTIVATE_SUBTITLE_1} <span className='font-semibold'>{`${selectedUserData !== undefined ? selectedUserData.firstName : ''} ${selectedUserData !== undefined ? selectedUserData.lastName : ''}`}</span> {UPDATE_USER_ACTIVATE_SUBTITLE_2}</p>
            }

          </DialogContent>
          <DialogActions sx={{ background: '#F9F9F9' }}>
            <OutlineButton color='gray' onClick={handleDeactivateUserClose} width='130px'>Cancel</OutlineButton>
            {/* <Button btntype="submit" label={!isModalSaveLoading ? "Delete" : <span className="loading loading-spinner loading-xs text-white"></span>} isGradient={true} color={"primary"} size={"small"} onClick={handleDeleteUserConfirm} disabled={isModalSaveLoading}></Button> */}
            <GradientButton color='red' onClick={() => {
              void handleDeactivateUserConfirm();
            }} width='130px'>{
                isModalSaveLoading ? (
                  <span className="loading loading-spinner loading-xs text-white"></span>
                ) : ((selectedUserData?.isActive) === true) ? "Deactivate" : "Activate"
              }</GradientButton>
          </DialogActions>
        </BootstrapDialog>
      </div>
    </>
  );
};

export default UserList;
